// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".warning[data-v-60b3788c]{color:orange}.publicationDate[data-v-60b3788c]{margin-top:2rem}", ""]);
// Exports
module.exports = exports;
